import Icon from './icon';
import Input from './input';
import InputTag from './input/input-tag';
import InputNumber from './input-number';
import InputTextarea from './input-textarea';
import InputGroup from './input-group';
import Loading from './loading';
import Button from './button';
import ButtonGroup from './button-group';
import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';
import Cascader from './cascader';
import CascaderPanel from './cascader-panel';
import Radio from './radio';
import RadioGroup from './radio-group';
import Modal from './modal';
import Form from './form';
import Select from './select';
import Tabs from './tabs';
import Table from './table';
import Pagination from './pagination';
import Steps from './steps';
import Menu from './menu';
import Upload from './upload';
import Mention from './mention';
import Row from './row';
import Col from './col';
import Tree from './tree';
import TreeSelect from './tree-select';
import DatePicker from './date-picker';
import TimePicker from './time-picker';
import Breadcrumb from './breadcrumb';
import Rate from './rate';
import Badge from './badge';
import Avatar from './avatar';
import Slider from './slider';
import Switch from './switch';
import Alert from './alert';
import Progress from './progress';
import Transfer from './transfer';
import Popup from './popup';
import Popconfirm from './popconfirm';
import Tooltip from './tooltip';
import Tag from './tag';
import Backtop from './backtop';
import Divider from './divider';
import Affix from './affix';
import Dropdown from './dropdown';
import Drawer from './drawer';
import AutoComplete from './auto-complete';
import Calendar from './calendar';
import Card from './card';
import Container from './container';
import Image from './image';
import ImageViewer from './image-viewer';
import Anchor from './anchor';
import InfiniteScroll from './infinite-scroll';

import ModalBox from './modal-box';
import Message from './message';
import Notification from './notification';

import Collapse from './collapse';

import config from './config';

import List, { RichList, CardList } from './list';

// 表格项
const { FormItem } = Form;
// 选择器
const { SelectOption, SelectOptionGroup } = Select;
// 标签页
const { TabsPane } = Tabs;
// 步骤条
const { Step } = Steps;
// 菜单
const { Item: MenuItem, Sub: Submenu } = Menu;
// 面包屑
const { BreadcrumbItem } = Breadcrumb;
// 下拉框
const { DropdownMenu, DropdownItem } = Dropdown;
// table
const { TableColumn } = Table;
// 容器
const { Header, Aside, Main, Footer } = Container;
//  折叠面板
const { CollapseItem } = Collapse;
// 提及
const { MentionOption } = Mention;
// 锚点
const { AnchorLink } = Anchor;

const components = {
  Icon,
  Input,
  InputTag,
  InputNumber,
  InputTextarea,
  InputGroup,
  Loading,
  Button,
  Row,
  Col,
  Checkbox,
  Cascader,
  CascaderPanel,
  Radio,
  Modal,
  Form,
  FormItem,
  Mention,
  MentionOption,
  Select,
  SelectOption,
  SelectOptionGroup,
  Tabs,
  TabsPane,
  Table,
  TableColumn,
  Pagination,
  Steps,
  Step,
  Menu,
  MenuItem,
  Submenu,
  Upload,
  Tree,
  TreeSelect,
  Breadcrumb,
  BreadcrumbItem,
  Rate,
  Badge,
  Avatar,
  Slider,
  Switch,
  Alert,
  Progress,
  ButtonGroup,
  Transfer,
  Popup,
  Popconfirm,
  Tooltip,
  RadioGroup,
  CheckboxGroup,
  Tag,
  Backtop,
  Divider,
  Affix,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Drawer,
  Anchor,
  AnchorLink,
  InfiniteScroll,
  DatePicker,
  TimePicker,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Notification,
  AutoComplete,
  Calendar,
  Card,
  Image,
  ImageViewer,
  Message,
  Collapse,
  CollapseItem,
  List,
  RichList,
  CardList,
};

const $modalBox = ModalBox;
const $message = Message;
const message = Message; // 旧版命名兼容
const $notify = Notification;

function install(Vue, config) {
  const defaults = {
    prefix: 'ten',
  };

  const installConfig = { ...defaults, ...config };
  Object.keys(components).forEach((key) => {
    Vue.component(installConfig.prefix + key, components[key]);
  });

  // 绑定指令
  Input.vFocus(Vue);

  Vue.use(InfiniteScroll);

  Object.assign(Vue.prototype, {
    $modalBox,
    $message,
    $notify,
  });
}

// install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}


export default {
  install,
  version: typeof __VERSION__ === 'undefined' ? '' : __VERSION__, // eslint-disable-line
  ...components,
  message,
  config,
};
